import {
    Box,
    Button,
    FormControl,
    IconButton,
    InputLabel,
    MenuItem,
    OutlinedInput,
    Select,
    TextField,
} from '@mui/material';
import * as React from 'react';
import { Controller, useForm } from 'react-hook-form';
import pxToRem from 'assets/theme/function/px-to-rem';
import { initialListData } from 'pages/cards-sphere';
import { CardsPersonageListRequest } from 'types/card/card-personage-list';
import { useSphereTitleListQuery } from 'store/slices/cards/sphere/sphere-list';
import { useStatusListQuery } from 'store/slices/user/user';
import CloseIcon from '@mui/icons-material/Close';

interface Props {
    setDataPersonageRequestList?: React.Dispatch<
        React.SetStateAction<CardsPersonageListRequest>
    >;
}
const FilterCardPersonage: React.FC<Props> = (props: Props) => {
    const { setDataPersonageRequestList } = props;

    const { handleSubmit, control, reset } =
        useForm<CardsPersonageListRequest>();
    const { data: statusList } = useStatusListQuery();

    const { data: sphereList } = useSphereTitleListQuery();
    const onSubmit = (values: CardsPersonageListRequest) => {
        if (setDataPersonageRequestList) {
            setDataPersonageRequestList((prevState) => ({
                ...prevState,
                title: values.title,
                code: values.code,
                sphereId: values.sphereId,
                status: values.status,
            }));
        }
    };
    const resets = () => {
        reset();
        if (setDataPersonageRequestList) {
            setDataPersonageRequestList(initialListData);
        }
    };

    return (
        <Box
            pt={pxToRem(10)}
            display={'flex'}
            justifyContent={'space-between'}
            alignItems={'center'}
            component="form"
            onSubmit={handleSubmit(onSubmit)}
        >
            <Box display={'flex'} flexBasis={'100%'}>
                <Controller
                    name="title"
                    control={control}
                    render={({
                        field: { name, value = '', onChange },
                        fieldState: { error },
                    }) => (
                        <TextField
                            label={'Personage Title'}
                            name={name}
                            value={value || ''}
                            sx={{ width: '30%' }}
                            onChange={onChange}
                            error={Boolean(error)}
                            helperText={error?.message || ''}
                        />
                    )}
                />

                <Controller
                    name="code"
                    control={control}
                    render={({
                        field: { name, value = '', onChange },
                        fieldState: { error },
                    }) => (
                        <TextField
                            label={'Personage Code'}
                            name={name}
                            value={value || ''}
                            onChange={onChange}
                            error={Boolean(error)}
                            helperText={error?.message || ''}
                            sx={{ ml: pxToRem(10), width: '30%' }}
                        />
                    )}
                />

                <FormControl sx={{ ml: pxToRem(10), width: '30%' }}>
                    <InputLabel>Sphere</InputLabel>
                    <Controller
                        name="sphereId"
                        control={control}
                        render={({ field: { name, value = '', onChange } }) => (
                            <Select
                                label="Sphere"
                                name={name}
                                value={value}
                                onChange={onChange}
                                input={
                                    <OutlinedInput
                                        label="Sphere"
                                        endAdornment={
                                            value && (
                                                <IconButton
                                                    size="small"
                                                    onClick={() => onChange('')}
                                                    sx={{
                                                        position: 'absolute',
                                                        top: '50%',
                                                        right: 25,
                                                        transform:
                                                            'translateY(-50%)',
                                                        zIndex: 1,
                                                    }}
                                                >
                                                    <CloseIcon fontSize="small" />
                                                </IconButton>
                                            )
                                        }
                                    />
                                }
                            >
                                {sphereList?.map((status) => (
                                    <MenuItem
                                        key={status.id.toString()}
                                        value={status.id.toString()}
                                    >
                                        {status.title}
                                    </MenuItem>
                                ))}
                            </Select>
                        )}
                    />
                </FormControl>

                <FormControl sx={{ ml: pxToRem(10), width: '30%' }}>
                    <InputLabel>Product Status</InputLabel>
                    <Controller
                        name="status"
                        control={control}
                        render={({ field: { name, value = '', onChange } }) => (
                            <Select
                                label="Product Status"
                                name={name}
                                value={value}
                                onChange={onChange}
                                input={
                                    <OutlinedInput
                                        label="Product Status"
                                        endAdornment={
                                            value && (
                                                <IconButton
                                                    size="small"
                                                    onClick={() => onChange('')}
                                                    sx={{
                                                        position: 'absolute',
                                                        top: '50%',
                                                        right: 25,
                                                        transform:
                                                            'translateY(-50%)',
                                                        zIndex: 1,
                                                    }}
                                                >
                                                    <CloseIcon fontSize="small" />
                                                </IconButton>
                                            )
                                        }
                                    />
                                }
                            >
                                {statusList?.map((status) => (
                                    <MenuItem
                                        key={status.toString()}
                                        value={status.toString()}
                                    >
                                        {status}
                                    </MenuItem>
                                ))}
                            </Select>
                        )}
                    />
                </FormControl>
            </Box>

            <Box display={'flex'} alignItems={'center'} ml={pxToRem(20)}>
                <Button
                    fullWidth
                    sx={{ mr: pxToRem(20), px: pxToRem(20) }}
                    variant={'contained'}
                    type={'submit'}
                >
                    Search
                </Button>
                <Button
                    fullWidth
                    sx={{ px: pxToRem(20) }}
                    variant={'contained'}
                    color={'secondary'}
                    onClick={resets}
                >
                    Clear
                </Button>
            </Box>
        </Box>
    );
};

export default FilterCardPersonage;
